import {
  EconomicInfoTypes,
  FinancialRatiosDataTypes,
  FinancialRatiosParamsTypes,
  FinancialReportsParamsTypes,
  FinancialReportsTypes,
  LinkDownloadFinancialReportsParamsTypes,
  LinkDownloadFinancialReportsTypes,
  StoxTBFundDataTypes,
  StoxTBFundParamsTypes,
  BusinessResultParamsDataTypes,
} from './types';

import axiosInstance from 'services/common/instance';

export const getEconomicInfoService = async (
  params?: string,
): Promise<EconomicInfoTypes[]> => {
  const res = await axiosInstance.get('ttpt-business-plan-statistics', { params });
  return res.data.data;
};

// data BussinessReult

export const getBusinessResultFundBankService = async (
  params: BusinessResultParamsDataTypes,
): Promise<StoxTBFundDataTypes> => {
  const response = await axiosInstance.get('ttpt-stox-tb-fund-bank/business-performance', { params });
  return response.data.data;
};

export const getBusinessResultFundInsuranceService = async (
  params: BusinessResultParamsDataTypes,
): Promise<StoxTBFundDataTypes> => {
  const response = await axiosInstance.get('ttpt-stox-tb-fund-insurance/business-performance', { params });
  return response.data.data;
};

export const getBusinessResultFundSecuritiesService = async (
  params: BusinessResultParamsDataTypes,
): Promise<StoxTBFundDataTypes> => {
  const response = await axiosInstance.get('ttpt-stox-tb-fund-securities/business-performance', { params });
  return response.data.data;
};

export const getBusinessResultFundCompanyService = async (
  params: BusinessResultParamsDataTypes,
): Promise<StoxTBFundDataTypes> => {
  const response = await axiosInstance.get('ttpt-stox-tb-fund-company/business-performance', { params });
  return response.data.data;
};

//

const getFinancialReportsService = async (
  params: FinancialReportsParamsTypes,
): Promise<FinancialReportsTypes> => {
  const response = await axiosInstance.get('ttpt-financial-reports', { params });
  return response.data;
};

export const getLinkDownloadFinancialReportsService = async (
  params: LinkDownloadFinancialReportsParamsTypes,
): Promise<LinkDownloadFinancialReportsTypes> => {
  const response = await axiosInstance.post('ttpt-financial-reports/create-download', params);
  return response.data.data;
};

export const getFinancialRatiosService = async (
  params: FinancialRatiosParamsTypes,
): Promise<FinancialRatiosDataTypes[]> => {
  const res = await axiosInstance.get('ttpt-financial-ratios', { params });
  return res.data.data;
};

/**
 * Bank
 */

// Bank - balance-sheet
export const getTtptStoxTBFundBankBalanceSheetService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-bank/balance-sheet', { params });
  return res.data.data;
};

// Bank - cash-flow-statement
export const getTtptStoxTBFundBankCashFlowStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-bank/cash-flow-statement', { params });
  return res.data.data;
};

// Bank - income-statement
export const getTtptStoxTBFundBankIncomeStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-bank/income-statement', { params });
  return res.data.data;
};

/**
 * Company
 */

// Company - balance-sheet
export const getTtptStoxTBFundCompanyBalanceSheetService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-company/balance-sheet', { params });
  return res.data.data;
};

// Company - cash-flow-statement
export const getTtptStoxTBFundCompanyCashFlowStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-company/cashflow-statement', { params });
  return res.data.data;
};

// Company - income-statement
export const getTtptStoxTBFundCompanyIncomeStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-company/income-statement', { params });
  return res.data.data;
};

/**
 * Insurance
 */

// Insurance - balance-sheet
export const getTtptStoxTBFundInsuranceBalanceSheetService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-insurance/balance-sheet', { params });
  return res.data.data;
};

// Insurance - cash-flow-statement
export const getTtptStoxTBFundInsuranceCashFlowStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-insurance/cashflow-statement', { params });
  return res.data.data;
};

// Insurance - cash-flow-statement
export const getTtptStoxTBFundInsuranceCashFlowStatementGTService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-insurance/cashflow-statement-gt', { params });
  return res.data.data;
};

// Insurance - income-statement
export const getTtptStoxTBFundInsuranceIncomeStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-insurance/income-statement', { params });
  return res.data.data;
};

/**
 * Securities
 */

// Securities - security-sheet
export const getTtptStoxTBFundSecuritiesBalanceSheetService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-securities/security-balance', { params });
  return res.data.data;
};

// Securities - cash-flow-statement
export const getTtptStoxTBFundSecuritiesCashFlowStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-securities/cashflow-statement', { params });
  return res.data.data;
};

// Securities - cash-flow-statement
export const getTtptStoxTBFundSecuritiesCashFlowStatementGTService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-securities/cashflow-statement-gt', { params });
  return res.data.data;
};

// Securities - income-statement
export const getTtptStoxTBFundSecuritiesIncomeStatementService = async (
  params: StoxTBFundParamsTypes,
): Promise<StoxTBFundDataTypes> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-securities/income-statement', { params });
  return res.data.data;
};

export default getFinancialReportsService;
